import { useQuery } from '@tanstack/react-query';
import { getEventSales } from '../api';

export const eventSalesKeys = {
  all: ['eventSales'],
  detail: (eventId) => ['eventSales', eventId],
};

export function useEventSales(eventId, options = {}) {
  return useQuery({
    queryKey: eventSalesKeys.detail(eventId),
    queryFn: async () => {
      const res = await getEventSales(eventId);
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!eventId,
    ...options,
  });
}
